!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = e || self).vkConnect = n();
}(this, function () {
  "use strict";

  var _i = function i() {
    return (_i = Object.assign || function (e) {
      for (var n, t = 1, o = arguments.length; t < o; t++) {
        for (var r in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function p(e, n) {
    var t = {};

    for (var o in e) {
      Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (t[o] = e[o]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
        n.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (t[o[r]] = e[o[r]]);
      }
    }

    return t;
  }

  var n = ["VKWebAppInit", "VKWebAppGetCommunityAuthToken", "VKWebAppAddToCommunity", "VKWebAppGetUserInfo", "VKWebAppSetLocation", "VKWebAppGetClientVersion", "VKWebAppGetPhoneNumber", "VKWebAppGetEmail", "VKWebAppGetGeodata", "VKWebAppSetTitle", "VKWebAppGetAuthToken", "VKWebAppCallAPIMethod", "VKWebAppJoinGroup", "VKWebAppAllowMessagesFromGroup", "VKWebAppDenyNotifications", "VKWebAppAllowNotifications", "VKWebAppOpenPayForm", "VKWebAppOpenApp", "VKWebAppShare", "VKWebAppShowWallPostBox", "VKWebAppScroll", "VKWebAppResizeWindow", "VKWebAppShowOrderBox", "VKWebAppShowLeaderBoardBox", "VKWebAppShowInviteBox", "VKWebAppShowRequestBox", "VKWebAppAddToFavorites"],
      a = [],
      s = null,
      e = "undefined" != typeof window,
      t = e && window.webkit && void 0 !== window.webkit.messageHandlers && void 0 !== window.webkit.messageHandlers.VKWebAppClose,
      o = e ? window.AndroidBridge : void 0,
      r = t ? window.webkit.messageHandlers : void 0,
      u = e && !o && !r,
      d = u ? "message" : "VKWebAppEvent";

  function f(e, n) {
    var t = n || {
      bubbles: !1,
      cancelable: !1,
      detail: void 0
    },
        o = document.createEvent("CustomEvent");
    return o.initCustomEvent(e, !!t.bubbles, !!t.cancelable, t.detail), o;
  }

  e && (window.CustomEvent || (window.CustomEvent = (f.prototype = Event.prototype, f)), window.addEventListener(d, function () {
    for (var n = [], e = 0; e < arguments.length; e++) {
      n[e] = arguments[e];
    }

    var t = function () {
      for (var e = 0, n = 0, t = arguments.length; n < t; n++) {
        e += arguments[n].length;
      }

      var o = Array(e),
          r = 0;

      for (n = 0; n < t; n++) {
        for (var i = arguments[n], p = 0, a = i.length; p < a; p++, r++) {
          o[r] = i[p];
        }
      }

      return o;
    }(a);

    if (u && n[0] && "data" in n[0]) {
      var o = n[0].data,
          r = (o.webFrameId, o.connectVersion, p(o, ["webFrameId", "connectVersion"]));
      r.type && "VKWebAppSettings" === r.type ? s = r.frameId : t.forEach(function (e) {
        e({
          detail: r
        });
      });
    } else t.forEach(function (e) {
      e.apply(null, n);
    });
  }));

  function l(e, n) {
    void 0 === n && (n = {}), o && "function" == typeof o[e] && o[e](JSON.stringify(n)), r && r[e] && "function" == typeof r[e].postMessage && r[e].postMessage(n), u && parent.postMessage({
      handler: e,
      params: n,
      type: "vk-connect",
      webFrameId: s,
      connectVersion: "1.6.8"
    }, "*");
  }

  function c(e) {
    a.push(e);
  }

  var b,
      v,
      w,
      A = {
    send: l,
    subscribe: c,
    sendPromise: (b = l, v = c, w = function () {
      var t = {
        current: 0,
        next: function next() {
          return this.current += 1, this.current;
        }
      },
          r = {};
      return {
        add: function add(e) {
          var n = t.next();
          return r[n] = e, n;
        },
        resolve: function resolve(e, n, t) {
          var o = r[e];
          o && (t(n) ? o.resolve(n) : o.reject(n), r[e] = null);
        }
      };
    }(), v(function (e) {
      if (e.detail && e.detail.data) {
        var n = e.detail.data,
            t = n.request_id,
            o = p(n, ["request_id"]);
        t && w.resolve(t, o, function (e) {
          return !("error_type" in e);
        });
      }
    }), function (o, r) {
      return new Promise(function (e, n) {
        var t = w.add({
          resolve: e,
          reject: n
        });
        b(o, _i(_i({}, r), {
          request_id: t
        }));
      });
    }),
    unsubscribe: function unsubscribe(e) {
      var n = a.indexOf(e);
      -1 < n && a.splice(n, 1);
    },
    isWebView: function isWebView() {
      return !(!o && !r);
    },
    supports: function supports(e) {
      return !(!o || "function" != typeof o[e]) || !(!r || !r[e] || "function" != typeof r[e].postMessage) || !(r || o || !n.includes(e));
    }
  };

  if ("object" != typeof exports || "undefined" == typeof module) {
    var y = null;
    "undefined" != typeof window ? y = window : "undefined" != typeof global ? y = global : "undefined" != typeof self && (y = self), y && (y.vkConnect = A, y.vkuiConnect = A);
  }

  return A;
});